import React from "react";
import { Button } from "react-bootstrap";
import iconPin from "assets/pin.svg";
import iconPinned from "assets/pinned.svg";
import { rest } from "lodash";
import Tooltip from "@emanprague/ppaskit/dist/Tooltip";

interface PinButtonProps {
  className?: string;
  size?: number;
  pinned: boolean;
  onToggle: (pinned: boolean) => void;
  pinnedText: string;
  unpinnedText: string;
  ariaLabelPinned: string;
  ariaLabelUnpinned: string;
}

export const PinButton: React.FC<PinButtonProps> = ({
  onToggle,
  pinned,
  className,
  pinnedText,
  unpinnedText,
  ariaLabelPinned,
  ariaLabelUnpinned,
  size = 32,
}) => {
  const text = pinned ? pinnedText : unpinnedText;
  const ariaLabel = pinned ? ariaLabelPinned : ariaLabelUnpinned;

  return (
    <Tooltip id="pin-toggle-tooltip" tooltip={text} wrap {...rest} placement="top">
      <Button
        id="pin-toggle"
        style={{ padding: `${Math.floor(size / 8)}px` }}
        className={className}
        variant="secondary"
        aria-label={ariaLabel}
        onClick={() => onToggle(!pinned)}>
        <img width={size} height={size} src={pinned ? iconPinned : iconPin} alt={text} />
      </Button>
    </Tooltip>
  );
};
